module.exports = __webpack_public_path__ + "img/委屈.c31b4f4a.png";